import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const visitCustomerRoute = ({
  DetailRateVisitCustomer,
  GeneralRateVisitCustomer,
  RatioReviewToTotalViews,
  EverageRatingOverTime,
  RatingUnsatisfied,
  WarrantyActiveReport,
  CustomerSurveyReport,
  // Báo cáo trạng thái công việc nvkt
  WorkStatusReport,
  StatisticsRevenueReport,
  StatisticsWarranty,

  CustomerGeneralReport,
}: {
  DetailRateVisitCustomer: React.ComponentType;
  GeneralRateVisitCustomer: React.ComponentType;
  RatioReviewToTotalViews: React.ComponentType;
  EverageRatingOverTime: React.ComponentType;
  RatingUnsatisfied: React.ComponentType;
  // Báo cáo kích hoạt bảo hành
  WarrantyActiveReport: React.ComponentType;
  CustomerSurveyReport: React.ComponentType;
  // Báo cáo trạng thái công việc nvkt
  WorkStatusReport: React.ComponentType;
  StatisticsRevenueReport: React.ComponentType;
  StatisticsWarranty: React.ComponentType;

  // báo cáo tổng hợp khách hàng
  CustomerGeneralReport: React.ComponentType;
}) => (
  <Routes>
    <Route path={ROUTES.REPORT_VISIT_CUSTOMER.BC_DETAIL_VISIT_CUSTOMER.BASE} element={<DetailRateVisitCustomer />} />
    <Route path={ROUTES.REPORT_VISIT_CUSTOMER.BC_GENERAL_VISIT_CUSTOMER.BASE} element={<GeneralRateVisitCustomer />} />
    <Route path={ROUTES.REPORT_VISIT_CUSTOMER.BC_RATIO_RATE.BASE} element={<RatioReviewToTotalViews />} />
    <Route path={ROUTES.REPORT_VISIT_CUSTOMER.BC_EVERAGE_RATING.BASE} element={<EverageRatingOverTime />} />
    <Route path={ROUTES.REPORT_VISIT_CUSTOMER.BC_RATING_UNSATISFIED.BASE} element={<RatingUnsatisfied />} />
    {/* Báo cáo kích hoạt bảo hành */}
    <Route path={ROUTES.REPORT_VISIT_CUSTOMER.BC_WARRANTY_ACTIVE.BASE} element={<WarrantyActiveReport />} />
    {/* Báo cáo khảo sát ý kiến của khách hàng */}
    <Route path={ROUTES.REPORT_VISIT_CUSTOMER.BC_CUSTOMER_SURVEY.BASE} element={<CustomerSurveyReport />} />
    {/* Báo cáo trạng thái công việc nvkt */}
    <Route path={ROUTES.REPORT_VISIT_CUSTOMER.BC_WORK_STATUS.BASE} element={<WorkStatusReport />} />

    <Route path={ROUTES.REPORT_VISIT_CUSTOMER.BC_STATISTICS_REVENUE.BASE} element={<StatisticsRevenueReport />} />
    <Route path={ROUTES.REPORT_VISIT_CUSTOMER.BC_STATISTICS_WARRANTY.BASE} element={<StatisticsWarranty />} />

    <Route path={ROUTES.REPORT_VISIT_CUSTOMER.BC_CUSTOMER_GENERAL.BASE} element={<CustomerGeneralReport />} />
  </Routes>
);
